module.exports = __webpack_public_path__ + "img/DatosVuelo1-64.985f7314.png";